import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const BlackListService = {
  getBlackList: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}blacklist`);
  },
  getBlackListByAccount: (accountId: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}blacklist/account/${accountId}`);
  },
  saveBlackList: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}blacklist`, data);
  },
  updateBlackList: (blacklist: string, data: any) => {
    return HTTP.patch<any, any>(`${API_ENDPOINT.CORE}blacklist/${blacklist}`, data);
  },
  addNumbersBlackListCsv: (data: any, blacklist: string) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}blacklist/${blacklist}`, data);
  },
  saveNumber: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}blacklist/phone-number`, data);
  },
  deleteBlackList: (blacklist: string) => {
    return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}blacklist/${blacklist}`);
  },
  deleteNumber: (blacklist: string, numberId: string) => {
    return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}blacklist/phone-number`, {
      data: {
        blacklist: blacklist,
        numberId: numberId
      }
    });
  },
  getCSVs: (blacklist: string, page: number, size: number) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}blacklist/phone_numbers/${blacklist}`, {
      params: {
        page: page,
        size: size
      }
    });
  }
};
